import React, {
    ReactElement,
    useEffect,
    useState,
    useCallback,
} from 'react';
import {SchemaWithClient} from '../../types/SchemaWithClient';
import {Entity} from '../../types/entities/Entity';
import {
    Button as MUIButton,
    Paper,
    Table,
    TableContainer,
} from '@mui/material';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import {SlidingPaneEdit} from '../Page/SlidingPaneEdit';
import api from '../../services/api';
import toast from 'react-hot-toast';
import TableBody from '@mui/material/TableBody';
import {SPNumberField} from '../Table/fields/SPNumberField';
import {enumItems} from '../../schema/enumItems';
import {formatNumber} from "../../reducer/actions/formatNumber";
import {SPSelectWithOutAutocomplete} from "../Table/fields/SPSelectWithOutAutocompleteField";

type Props<T extends Entity> = {
    schema: SchemaWithClient<T>;
};

export const Finance = ({
                            schema,
                            values,
                            fullWidth,
                            onChange,
                        }: {
    schema: any;
    values: any;
    fullWidth: boolean;
    onChange: (value: any, column: string) => void;
}): ReactElement => {
    const [openConfirmDialog, setOpenConfirmDialog] = useState<any>(false);
    const [properties, setProperties] = useState<any>(undefined);
    const [openedSlidingPane, setOpenedSlidingPane] = useState<any>({});
    const [mnbRates, setMnbRates] = useState<any>(false);
    const [financeData, setFinanceData] = useState<any>(values?.finances);
    const [forcedValue, setForcedValue] = useState<any>({});
    const [baseCurrency, setBaseCurrency] = useState<any>(values.group?.base_currency ? values.group?.base_currency : {
        id: 1,
        name: 'EUR'
    });

    const fetchData = useCallback(() => {
        const searchParams = new URLSearchParams({
            activity: values?.id,
        });

        api.get('/activity-contacts', searchParams).then((res: any) => {
            setProperties(res);
        });
    }, []);

    const fetchMnbRates = useCallback(() => {
        const searchParams = new URLSearchParams({
            activity: values?.id,
        });

        api.get(`/mnb-rates/group/${values?.group?.id}`, searchParams).then((res: any) => {
            setMnbRates(res);
        });
    }, []);

    useEffect(() => {
        //fetchData();
        fetchMnbRates();
    }, []);

    const calculateFinal = ()=>{
        if (financeData?.final_price_currency?.id && values.group?.base_currency?.id){
            if (financeData?.final_price_currency?.id !== values.group?.base_currency?.id){

                let price = {...financeData}.final_price;
                if (values.group?.base_currency?.id===1){
                    price = price / mnbRates.EUR;
                }
                if (values.group?.base_currency?.id===2){
                    price = price / mnbRates.HUF;
                }

                setFinanceData({...financeData, final_price_in_base_currency: price})

            }else{
                setFinanceData({...financeData, final_price_in_base_currency: financeData.final_price})
            }
        }
    };
    const handleChangeCost = (value:any, type:string)=>{

        if (type==='pp'){
            const newFinalCost = value * (values?.size ? values.size : 1);
            onChange(newFinalCost, 'final_cost');
            setFinanceData({...financeData, final_cost: newFinalCost});
        }else{
            const newFinalPPCost = value / (values?.size ? values.size : 1);
            setFinanceData({...financeData, final_cost_pp: newFinalPPCost});
            onChange(value, 'final_cost');
        }

    };

    return (
        <>

            <TableContainer
                component={Paper}
                sx={{
                    width: 'auto',
                }}
            >
                <Table aria-label="simple table" size="small">
                    <TableHead
                        sx={{
                            '& .MuiTableCell-root': {
                                color: 'inherit',
                                border: 'none',
                            },
                            '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                                border: 'none',
                                fontSize: '14px',
                                p: '10px 15px',
                            },
                            '& .MuiTableRow-root .MuiTableCell-root .MuiFormControl-root.MuiTextField-root': {
                                background: '#f9f9f9',
                                boxShadow: 'inset 0px 0px 1px #a7a7a7',
                            },
                            background: '#256861',
                            color: '#fff',
                        }}
                    >
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell sx={{textAlign: 'right'}}>PP</TableCell>
                            <TableCell sx={{textAlign: 'right'}}>SUM</TableCell>
                            <TableCell sx={{textAlign: 'center'}}>CCY</TableCell>
                            <TableCell sx={{textAlign: 'right'}}>VAT %</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody
                        sx={{
                            '& .MuiTableCell-root': {
                                p: '5px 10px',
                            },
                            '& .MuiInputBase-root.MuiOutlinedInput-root': {
                                paddingRight: '0px',
                            },
                        }}
                    >
                        <TableRow sx={{
                            /* background: '#f3f3f3',
                             '& .MuiInputBase-root.MuiOutlinedInput-root': {
                               background: '#f3f3f3'
                             },*/
                        }}>
                            <TableCell>Original Gross Cost</TableCell>
                            <TableCell sx={{textAlign: 'right'}}>
                                {financeData?.original_cost_value_pp ? formatNumber(financeData?.original_cost_value_pp) : ''}
                            </TableCell>
                            <TableCell sx={{textAlign: 'right'}}>
                                 {financeData?.original_cost_value ? formatNumber(financeData?.original_cost_value) : ''}
                            </TableCell>
                            <TableCell>
                                 {financeData?.original_cost_currency?.name}
                            </TableCell>
                            <TableCell sx={{textAlign: 'right'}}>
                                {financeData?.vat}
                            </TableCell>
                        </TableRow>
                        <TableRow

                          sx={{
                              '& .MuiTableCell-root':{
                                  fontWeight: 'bold',
                              },
                              '& .MuiInputBase-root.MuiOutlinedInput-root': {
                                  background: '#f9f9f9',
                                  boxShadow: 'inset 0px 0px 1px #5b5b5b',

                                  '& .MuiInputBase-input':{
                                      fontWeight: 'bold',
                                  }

                              },
                          }}
                        >
                            <TableCell>
                                <b>Final Gross Cost</b>
                            </TableCell>
                            <TableCell>
                                <SPNumberField
                                  withOutEndAdornment={true}
                                    isActive
                                    defaultValue={financeData?.final_cost_pp}
                                    onChange={(value) => {
                                        handleChangeCost(value,'pp');
                                    }}
                                />
                            </TableCell>
                            <TableCell>
                                <SPNumberField
                                  withOutEndAdornment={true}
                                    isActive
                                    defaultValue={financeData?.final_cost}
                                    onChange={(value) => {
                                        handleChangeCost(value,'full');
                                    }}
                                />
                            </TableCell>
                            <TableCell>
                                <SPSelectWithOutAutocomplete
                                    onChange={(value) => {
                                        onChange(value, 'final_cost_currency');
                                    }}
                                    schema={enumItems.currency}
                                    defaultValue={financeData?.final_cost_currency}
                                    forcedValue={undefined}
                                    disabled={false}
                                    isMissing={false}
                                    accordingToValue={undefined}
                                />
                            </TableCell>
                            <TableCell sx={{textAlign: 'right'}}>
                               {/* <SPNumberField
                                  isActive
                                  defaultValue={financeData?.vat}
                                  onChange={(value) => {
                                  }}
                                />*/}
                                {financeData?.vat}
                            </TableCell>
                        </TableRow>

                    </TableBody>
                </Table>
            </TableContainer>

            {openConfirmDialog && (
                <Dialog
                    open={openConfirmDialog}
                    onClose={() => {
                        setOpenConfirmDialog(false);
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {'Are you sure you want to delete it?'}
                    </DialogTitle>
                    <DialogActions>
                        <MUIButton
                            onClick={() => {
                                setOpenConfirmDialog(false);
                            }}
                        >
                            Cancel
                        </MUIButton>
                        <MUIButton
                            variant={'contained'}
                            color={'error'}
                            onClick={() => {
                                const deletedRow = openConfirmDialog?.row;
                                openConfirmDialog?.schema.client
                                    .delete(deletedRow.id as number, {id: deletedRow.id})
                                    .then((res: any) => {
                                        const tempProperties = [...properties];

                                        const newRows = tempProperties.filter((contact: any) => {
                                            return contact?.id !== deletedRow?.id;
                                        });
                                        setProperties(newRows);
                                        toast.success(
                                            `Successfully deleted ${schema.name}: ${
                                                deletedRow?.name ? deletedRow?.name : deletedRow?.id
                                            }`
                                        );
                                        setOpenConfirmDialog(false);
                                    })
                                    .catch((e: any) => {
                                        console.log(e);
                                        toast.error(
                                            `Error: Unable to delete ${schema.name}: ${
                                                deletedRow?.name ? deletedRow?.name : deletedRow?.id
                                            }`
                                        );
                                    });
                            }}
                            autoFocus
                        >
                            Delete
                        </MUIButton>
                    </DialogActions>
                </Dialog>
            )}

            {openedSlidingPane?.row?.id && (
                <SlidingPaneEdit
                    schema={openedSlidingPane?.schema}
                    id={openedSlidingPane?.row?.id}
                    onSubmit={() => {
                        setOpenedSlidingPane({});
                        fetchData();

                        toast.success(`Successfully updated ${schema.name}`);
                    }}
                    propertiesFromTable={
                        openedSlidingPane?.row ? openedSlidingPane?.row : {}
                    }
                    onClose={(value) => {
                        setOpenedSlidingPane({});
                    }}
                />
            )}
        </>
    );
};
